import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { API } from "../../lib/api";
import { Loading } from "../../components/common";

const SLUGS = [["terms", "Terms of Service"], ["privacy", "Privacy Policy"],
  ["e-communications", "Electronic Communications Consent"], ["payment-authorization", "Payment Authorization"],
  ["filing-authorization", "Tax Filing Authorization"], ["security", "Security Policy"],
  ["refund", "Refund & Cancellation Policy"]];

export default function Legal() {
  const { slug } = useParams();
  const [doc, setDoc] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    setDoc(null); setErr("");
    API.get(`/public/legal/${slug}`).then((r) => setDoc(r.data)).catch(() => setErr("Document not found."));
  }, [slug]);

  return (
    <div className="mx-auto grid max-w-6xl gap-8 px-4 py-14 sm:px-6 lg:grid-cols-4">
      <aside className="lg:col-span-1">
        <div className="label-gov">Legal Documents</div>
        <ul className="space-y-1">
          {SLUGS.map(([s, l]) => (
            <li key={s}><Link to={`/legal/${s}`} className={`block rounded px-3 py-2 text-sm font-medium ${s === slug ? "bg-navy text-white" : "text-slate-600 hover:bg-slate-100"}`} data-testid={`legal-nav-${s}`}>{l}</Link></li>
          ))}
        </ul>
      </aside>
      <article className="lg:col-span-3">
        {err && <div className="text-rose-700">{err}</div>}
        {!doc && !err && <Loading label="Loading document" />}
        {doc && (
          <div className="card-gov p-8" data-testid="legal-document">
            <h1 className="text-3xl font-bold tracking-tight text-navy">{doc.title}</h1>
            <div className="mt-1 text-xs text-slate-400">Version {doc.version} · Last updated {new Date(doc.updated_at).toLocaleDateString()}</div>
            <p className="mt-6 leading-relaxed text-slate-600">{doc.body}</p>
            <p className="mt-6 border-t border-slate-200 pt-4 text-xs text-slate-400">Questions about this document? Contact AZ Tax Accounts support. Legal language is maintained by the company and versioned in our administration system.</p>
          </div>
        )}
      </article>
    </div>
  );
}
